var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sun",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.333,8.167A8.167,8.167,0,1,1,8.167,0,8.167,8.167,0,0,1,16.333,8.167Z",
    transform: "translate(5.833 5.833)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.833,25.62a1.131,1.131,0,0,1-1.167-1.12v-.093a1.167,1.167,0,0,1,2.333,0A1.211,1.211,0,0,1,12.833,25.62Zm8.33-3.29a1.2,1.2,0,0,1-.828-.338l-.152-.152a1.163,1.163,0,0,1,1.645-1.645l.152.152a1.162,1.162,0,0,1,0,1.645A1.148,1.148,0,0,1,21.163,22.33Zm-16.66,0a1.2,1.2,0,0,1-.828-.338,1.162,1.162,0,0,1,0-1.645l.152-.152A1.163,1.163,0,0,1,5.472,21.84l-.152.152A1.168,1.168,0,0,1,4.5,22.33ZM24.5,14h-.093a1.167,1.167,0,0,1,0-2.333,1.211,1.211,0,0,1,1.213,1.167A1.131,1.131,0,0,1,24.5,14ZM1.26,14H1.167a1.167,1.167,0,0,1,0-2.333A1.211,1.211,0,0,1,2.38,12.833,1.131,1.131,0,0,1,1.26,14ZM21.012,5.822a1.2,1.2,0,0,1-.828-.338,1.162,1.162,0,0,1,0-1.645l.152-.152A1.163,1.163,0,0,1,21.98,5.332l-.152.152A1.148,1.148,0,0,1,21.012,5.822Zm-16.357,0a1.2,1.2,0,0,1-.828-.338L3.675,5.32A1.163,1.163,0,0,1,5.32,3.675l.152.152a1.162,1.162,0,0,1,0,1.645A1.132,1.132,0,0,1,4.655,5.822ZM12.833,2.38a1.131,1.131,0,0,1-1.167-1.12V1.167a1.167,1.167,0,0,1,2.333,0A1.211,1.211,0,0,1,12.833,2.38Z",
    transform: "translate(1.167 1.167)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon-sun.09a807958f4787a394660791b4e9165d.svg";
export { ForwardRef as ReactComponent };